/**
 * Whether the viewport is a phone's: at or below the width where the app
 * switches to its phone layout.
 */import useMediaQuery from"web/shared/hooks/useMediaQuery";import{PHONE_MAX_WIDTH_PX}from"web/shared/breakpoints";const PHONE_QUERY="(max-width: ".concat(PHONE_MAX_WIDTH_PX,"px)");export default function useIsPhoneViewport(){return useMediaQuery(PHONE_QUERY);}